"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTES = void 0;
var ROUTES;
(function (ROUTES) {
    ROUTES["CREATE_ORG"] = "/api/accounts/v5/organizations/create";
    ROUTES["UPDATE_ORG"] = "/api/accounts/v5/organizations/update";
    ROUTES["UPDATE_ORG_BILLING"] = "/api/accounts/v5/organizations/update-billing";
    ROUTES["GET_ORG"] = "/api/accounts/v5/organizations/get";
    ROUTES["LIST_ORGS"] = "/api/accounts/v5/organizations/list";
    ROUTES["SEARCH_ORGS"] = "/api/accounts/v5/organizations/search";
    ROUTES["UPDATE_ORG_LOCKS"] = "/api/accounts/v5/organizations/update-locks";
    ROUTES["CREATE_USER"] = "/api/accounts/v5/users/create";
    ROUTES["UPDATE_USER"] = "/api/accounts/v5/users/update";
    ROUTES["DELETE_USER"] = "/api/accounts/v5/users/delete";
    ROUTES["GET_USER"] = "/api/accounts/v5/users/get";
    ROUTES["LIST_USERS"] = "/api/accounts/v5/users/list";
    ROUTES["SEARCH_USERS"] = "/api/accounts/v5/users/search";
    ROUTES["GIVE_USER_ACCESS"] = "/api/accounts/v5/organizations/give-user-access";
    ROUTES["START_SIGNUP"] = "/api/accounts/v5/signup/start";
    ROUTES["GET_SIGNUP_USER"] = "/api/accounts/v5/signup/get-user";
    ROUTES["COMPLETE_SIGNUP"] = "/api/accounts/v5/signup/complete-signup";
    ROUTES["PROVISION_USER_TOKEN"] = "/api/accounts/v5/signup/provision-user-token";
    ROUTES["CREATE_DEV_INVITE"] = "/api/accounts/v5/invites/create";
    ROUTES["UPDATE_INVITE"] = "/api/accounts/v5/invites/update";
    ROUTES["DESTROY_INVITE"] = "/api/accounts/v5/invites/destroy";
    ROUTES["GET_USER_INVITES"] = "/api/accounts/v5/invites/user-invites";
    ROUTES["LIST_DEV_INVITES"] = "/api/accounts/v5/invites/list";
    ROUTES["ACCEPT_INVITE"] = "/api/accounts/v5/invites/accept";
    ROUTES["DECLINE_INVITE"] = "/api/accounts/v5/invites/decline";
    ROUTES["DOWNGRADE_APP_TO_TRIAL"] = "/api/accounts/v5/apps/downgrade-to-trial";
    ROUTES["UPGRADE_APP_FROM_TRIAL"] = "/api/accounts/v5/apps/upgrade-from-trial";
    ROUTES["UPDATE_APP_LOCKS"] = "/api/accounts/v5/apps/update-locks";
    ROUTES["EXTEND_TRIAL"] = "/api/accounts/v5/apps/extend-trial";
    ROUTES["CREATE_APP"] = "/api/accounts/v5/apps/create";
    ROUTES["UPDATE_APP"] = "/api/accounts/v5/apps/update";
    ROUTES["DELETE_APP"] = "/api/accounts/v5/apps/delete";
    ROUTES["GET_APP"] = "/api/accounts/v5/apps/get";
    ROUTES["LIST_APPS"] = "/api/accounts/v5/apps/list";
    ROUTES["SEARCH_APPS"] = "/api/accounts/v5/apps/search";
    ROUTES["GET_SENSITIVE_ACCESS_TOKEN"] = "/me/profile/auth_for_token";
    ROUTES["GET_PREFERRED_FACTOR"] = "/me/profile/get_preferred_factor";
    ROUTES["LIST_MFA_FACTORS"] = "/me/profile/list_mfa_factors";
    ROUTES["SEND_MFA_SMS"] = "/me/profile/request_otp_sms";
    ROUTES["REGISTER_TOTP_USER_MFA_FACTOR"] = "/me/profile/register_totp_factor";
    ROUTES["REGISTER_SMS_USER_MFA_FACTOR"] = "/me/profile/register_sms_factor";
    ROUTES["SET_PREFERRED_MFA_METHOD"] = "/me/profile/set_preferred_factor";
    ROUTES["DELETE_MFA_FACTOR"] = "/me/profile/delete_factor";
    ROUTES["VERIFY_MFA_FACTOR"] = "/me/profile/verify_factor";
    ROUTES["GENERATE_MFA_BACKUP_CODES"] = "/me/profile/generate_backup_codes";
})(ROUTES || (exports.ROUTES = ROUTES = {}));
